import { render, staticRenderFns } from "./MsgMailDialog.vue?vue&type=template&id=3e3d115b"
import script from "./MsgMailDialog.vue?vue&type=script&lang=js"
export * from "./MsgMailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports